import { createFileRoute, redirect } from "@tanstack/react-router";
import { resumeTarget } from "@vd/ui";

/**
 * `/admin/resume`: where the ops console's Admin segment lands (DESIGN.md "Mode switch"). It
 * opens `to` when that is an Admin page, else the last Admin page this tab showed, else Home.
 */
export const Route = createFileRoute("/admin/resume")({
  staticData: { crumb: { label: "Admin", parents: [] } },
  validateSearch: (s: Record<string, unknown>): { to?: string } =>
    typeof s.to === "string" && s.to ? { to: s.to } : {},
  beforeLoad: ({ search }) => {
    throw redirect({ href: resumeTarget("admin", search.to), replace: true });
  },
});
